export const ENABLE_TRIAL = __DEV__ ? false : false;
export const ENABLE_CHECK_PRODUCT_PERMISSION = __DEV__ ? false : false;
export const ENABLE_CHECK_ROLE_PERMISSION = __DEV__ ? true : true;
export const ENABLE_HKEC = __FEATURE_FLAGS__.ENABLE_HKEC;
export const ENABLE_TANXING_LUOJINSHU = __FEATURE_FLAGS__.ENABLE_TANXING_LUOJINSHU;
export const ENABLE_MSP = true;
export const ENABLE_CLOUD_MONITOR = true;
export const ENABLE_ALB = __FEATURE_FLAGS__.ENABLE_ALB;
export const ENABLE_AI_ASSISTANT = __FEATURE_FLAGS__.ENABLE_AI_ASSISTANT;
export const ENABLE_TEMPLATE_REFERENCE = __FEATURE_FLAGS__.ENABLE_TEMPLATE_REFERENCE;
export const ENABLE_DEBUG_EXISTED_EPC_PAGINATION = __FEATURE_FLAGS__.ENABLE_DEBUG_EXISTED_EPC_PAGINATION;

console.log(`feature flags:
ENABLE_TRIAL: ${ENABLE_TRIAL}
ENABLE_CHECK_ROLE_PERMISSION: ${ENABLE_CHECK_ROLE_PERMISSION}
ENABLE_CHECK_PRODUCT_PERMISSION: ${ENABLE_CHECK_PRODUCT_PERMISSION}
ENABLE_CHECK_KCE_1.0: ${__FEATURE_FLAGS__.ENABLE_CHECK_KCE_1_0}
ENABLE_HKEC: ${ENABLE_HKEC}
ENABLE_TANXING_LUOJINSHU: ${ENABLE_TANXING_LUOJINSHU}
USE_NON_LOCAL_MONACO_EDITOR: ${import.meta.env.VITE_USE_NON_LOCAL_MONACO_EDITOR}
ENABLE_CLOUD_MONITOR: ${ENABLE_CLOUD_MONITOR}
ENABLE_MSP: ${ENABLE_MSP}
ENABLE_ALB: ${ENABLE_ALB}
ENABLE_AI_ASSISTANT: ${ENABLE_AI_ASSISTANT}
ENABLE_TEMPLATE_REFERENCE: ${ENABLE_TEMPLATE_REFERENCE}
ENABLE_DEBUG_EXISTED_EPC_PAGINATION: ${ENABLE_DEBUG_EXISTED_EPC_PAGINATION}
`);
